<div class="bgColor">
    <div class="overtime-container container">
        <div class="row">
            <div class="overtime-left-col col-md-6">
                <div class="overtime-left">
                    <h2 class="title-head">Overtime</h2>
                    <div class="d-flex">
                        <span>32 Request</span>
                    </div>
                </div>

            </div>
            <div class="overtime-right-col col-md-6">
                <div class="overtime-right">
                    <div class="status-dropdown">
                        <img src="../../../../../../assets/img/Attendence Icon/twemoji_flag-india.svg" alt="Flag Icon">
                        <select class="flag">
                            <option value="in">INDIA</option>
                            <option value="in">Japan</option>
                        </select>
                    </div>
                    <button class="report-button primary"> overtime Report</button>
                </div>

            </div>
        </div>
    </div>



    <div class="container mt-0 attendance-card-container">
        <div class="row g-3">

            <!-- Approved Status Summary Card -->
            <div class="col-md-6">
                <div class="card border-0 attendance-grid-card">
                    <div class="p-2 d-flex justify-content-between align-items-center border-0">

                        <span class="mb-0"><img src="../../../../../../assets/img/Attendence Icon/clipboard-text2.svg" alt=""><span class="card-head"> Approval Status</span> </span>
                        <span class="menu">...</span>
                    </div>
                    <div class="card-body">
                        <div class="row text-center">
                            <div class="col border-end">
                                <p class="mb-1 attendance-grid-title">Outline</p>
                                <h6>265</h6>
                                <div class="compare">
                                    <span>+12 vs </span><span>Yesterday</span>
                                </div>
                            </div>
                            <div class="col border-end">
                                <p class="mb-1 attendance-grid-title">Late Clock-In</p>
                                <h6>65</h6>
                                <div class="compare">
                                    <span>-6 vs </span><span>Yesterday</span>
                                </div>
                            </div>
                            <div class="col">
                                <p class="mb-1 attendance-grid-title">Early Check In</p>
                                <h6>224</h6>
                                <div class="compare">
                                    <span>-6 vs </span><span>Yesterday</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Overtime Summary Card -->
            <div class="col-md-6">
                <div class="card border-0 attendance-grid-card">
                    <div class="p-2 d-flex justify-content-between align-items-center border-0">

                        <span class="mb-0"><img src="../../../../../../assets/img/Attendence Icon/user-remove.svg" alt=""><span class="card-head"> Overtime Summary</span> </span>
                        <span class="menu">...</span>
                    </div>
                    <div class="card-body">
                        <div class="row text-center">
                            <div class="col border-end">
                                <p class="mb-1 attendance-grid-title">Absence</p>
                                <h6>42</h6>
                                <div class="compare">
                                    <span>+12 vs </span><span>Yesterday</span>
                                </div>
                            </div>
                            <div class="col border-end">
                                <p class="mb-1 attendance-grid-title">No Clock-In</p>
                                <h6>0</h6>
                                <div class="compare">
                                    <span>-6 vs </span><span>Yesterday</span>
                                </div>
                            </div>
                            <div class="col">
                                <p class="mb-1 attendance-grid-title">No Clock Out</p>
                                <h6>0</h6>
                                <div class="compare">
                                    <span>-6 vs </span><span>Yesterday</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- attendance filter -->

    <div class="container attendance-filter">
        <div class="row">
            <div class="filter-container gap-2 align-items-center">
                <!-- Search Input -->

                <div class="input-group search-group">
                    <span class="input-group-text bg-white search-group-icon">
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </span>
                    <input type="text" class="form-control search-group-input" placeholder="Search here"
                        aria-label="Search">
                </div>


                <!-- All compensation Button -->
                <div class="btn-group">
                    <button type="button" class="btn btn-outline-secondary dropdown-toggle all-compensation"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fa-solid fa-list"></i> All Compensation 
                    </button>
                    <ul class="dropdown-menu all-compensation-list">
                        <li><a class="dropdown-item" href="#">Last 7 Days</a></li>
                        <li><a class="dropdown-item" href="#">Last 30 Days</a></li>
                        <li><a class="dropdown-item" href="#">Custom Range</a></li>
                    </ul>
                </div>

                <!-- All Department Button -->
                <div class="btn-group">
                    <button type="button" class="btn btn-outline-secondary dropdown-toggle all-compensation"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fa-solid fa-list"></i> All Department 
                    </button>
                    <ul class="dropdown-menu all-compensation-list">
                        <li><a class="dropdown-item" href="#">Last 7 Days</a></li>
                        <li><a class="dropdown-item" href="#">Last 30 Days</a></li>
                        <li><a class="dropdown-item" href="#">Custom Range</a></li>
                    </ul>
                </div>

                <!-- Attendance Filters Button -->
                <div class="btn-group">
                    <button type="button" class="btn btn-outline-secondary dropdown-toggle attendance-filter-btn"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fa-solid fa-filter"></i> Attendance Filters
                    </button>
                    <ul class="dropdown-menu attendance-filter-list">
                        <li><a class="dropdown-item" href="#">Present</a></li>
                        <li><a class="dropdown-item" href="#">Absent</a></li>
                        <li><a class="dropdown-item" href="#">Late Clock-In</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!--Overtime Table -->
    <div class="bg-color">
        <div class="container">
            <p-table styleClass="p-datatable-gridlines" [value]="products" [tableStyle]="{'min-width': '60rem'}"
                [paginator]="true" [rows]="5" [rowsPerPageOptions]="[5, 10, 20]">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="code" style="width:18%">
                            <i class="fa-regular fa-calendar-days"></i> Request Date
                            <i class="fa-solid fa-sort table-sort-icon"></i>
                        </th>
                        <th pSortableColumn="code" style="width:20%">
                            <i class="fa-regular fa-calendar-days"></i> Overtime Date
                            <i class="fa-solid fa-sort table-sort-icon"></i>
                        </th>
                        <th pSortableColumn="code" style="width:20%">
                            <img src="../../../../../../assets/img/Attendence Icon/user.svg" alt=""> Employee name /ID
                            <i class="fa-solid fa-sort table-sort-icon"></i>
                        </th>
                        <th pSortableColumn="name" style="width:12%">
                            <img src="../../../../../../assets/img/Attendence Icon/Vector-2.svg" alt=""> Duration <i class="fa-solid fa-sort table-sort-icon" field="name"></i>
                        </th>
                        <th pSortableColumn="category" style="width:20%">
                            <i class="fa-regular fa-clock"></i> Overtime <i
                                class="fa-solid fa-sort table-sort-icon"></i>
                        </th>
                       
                        <th pSortableColumn="quantity" style="width:20%">
                            <img src="../../../../../../assets/img/Attendence Icon/Vector-1.svg" alt=""> Reason
                            <i class="fa-solid fa-sort table-sort-icon"></i>
                        </th>
                        <th pSortableColumn="quantity" style="width:10%">
                            <img src="../../../../../../assets/img/Attendence Icon/Vector.svg" alt=""> Action <i
                                class="fa-solid fa-sort table-sort-icon"></i>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>{{ product.name }}</td>
                        <td>{{ product.name }}</td>
                        <td>
                            <div class="d-flex employee-image">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/User_icon_2.svg/1200px-User_icon_2.svg.png"
                                    class="attendance-table-user-image" alt="">
                                <div class="align-content-center">
                                    <div>{{product.code}}</div>
                                    <span class="user-mobile-number">358223289</span>
                                </div>
                            </div>
                        </td>
                        <td>3 Hours</td>
                        <td>
                            <div class="time-container">
                                <span class="time time-start">10:02 AM - </span>
                                
                                <span class="time time-end">07:00 PM</span>
                            </div>
                        </td>
                        
                        <td>{{ product.category }}</td>
                        <td><div class="d-flex">
                            <span class="x-btn"><i class="fa-solid fa-xmark"></i></span><button class="btn btn-sm d-flex approveBtn">
                           <i class="fa-solid fa-check"></i>Approve
                           </button>
                           </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

</div>